import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import DeleteIcon from '@material-ui/icons/Delete'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import useStyles, { AddableSectionWrapper, InnerAddable } from './title-content-input.styles'
import { HelperMsg, SectionTitle } from '../coaches-profile/profile.styles'
import TextFieldCounter from '../text-field-counter'

const TitleContentInput = (props) => {
  const {
    addButtonLabel,
    contentLabel,
    onChange,
    addItem,
    removeItem,
    headline,
    subtitle,
    maxContentLength,
    maxItems,
    titleLabel,
    fieldName,
    values: items,
    errors,
    touched,
  } = props
  const styles = useStyles()

  return (
    <div>
      <SectionTitle>{headline}</SectionTitle>
      <HelperMsg>{subtitle}</HelperMsg>
      {items && items.length > 0
        ? items.map((item, i) => (
        // eslint-disable-next-line react/no-array-index-key
          <AddableSectionWrapper key={`title-content-${item.id}}`}>
            <InnerAddable>
              <TextField
                name={`${fieldName}.${i}.name`}
                label={titleLabel}
                type="text"
                variant="standard"
                value={item.name}
                onChange={onChange}
                className={`${styles.textFields} text-input ${errors && errors[i] && errors[i].name && touched && touched[i] && touched[i].name && ' error'}`}
                error={errors && errors[i] && errors[i].name && touched && touched[i] && touched[i].name}
                helperText={touched && touched[i] && touched[i].name && errors && errors[i] && errors[i].name}
              />
              <FormControl error={errors && errors[i] && errors[i].description}>
                <TextFieldCounter
                  style={{ marginBottom: 0 }}
                  multiline
                  characterLimit={maxContentLength}
                  rows={4}
                  name={`${fieldName}.${i}.description`}
                  label={contentLabel}
                  type="text"
                  variant="outlined"
                  value={item.description}
                  onChange={onChange}
                  className={`${styles.textFields} multiline text-input ${errors && errors[i] && errors[i].description && touched && touched[i] && touched[i].description && ' error'}`}
                  error={errors && errors[i] && errors[i].description && touched && touched[i] && touched[i].description}
                />
                <FormHelperText>{touched && touched[i] && touched[i].description && errors && errors[i] && errors[i].description}</FormHelperText>
              </FormControl>
            </InnerAddable>
            <Button
              variant="text"
              size="large"
              type="button"
              onClick={() => removeItem(i)}
              startIcon={<DeleteIcon />}
            >
              Delete
            </Button>
          </AddableSectionWrapper>
        )) : null
      }
      <Box>
        <Button
          style={{ marginTop: '20px' }}
          variant="outlined"
          color="primary"
          size="large"
          type="button"
          onClick={addItem}
          disabled={items && items.length >= maxItems}
        >
          {addButtonLabel}
        </Button>
      </Box>
    </div>
  )
}

TitleContentInput.propTypes = {
  addItem: PropTypes.func,
  addButtonLabel: PropTypes.string,
  contentLabel: PropTypes.string,
  fieldName: PropTypes.string,
  headline: PropTypes.string,
  maxContentLength: PropTypes.number,
  maxItems: PropTypes.number,
  onChange: PropTypes.func,
  removeItem: PropTypes.func,
  subtitle: PropTypes.string,
  titleLabel: PropTypes.string,
  values: PropTypes.array,
  errors: PropTypes.array,
  touched: PropTypes.array,
}

TitleContentInput.defaultProps = {
  addButtonLabel: 'Add Item',
}

export default TitleContentInput
